import React, { useEffect, useState } from "react";
import { EXPORT_EVENT } from "../exportDetails.js";

/* The one export progress panel, mounted in the app shell. Any page that calls
   downloadCsvWithDetails gets it for free: "Preparing your CSV — 400 of 1,467 companies", then
   "Downloaded 636 rows" for a few seconds. */
export default function ExportStatus() {
  const [st, setSt] = useState(null);
  useEffect(() => {
    let t = null;
    const on = (e) => {
      const d = e.detail || {};
      clearTimeout(t);
      setSt(d);
      if (d.phase === "done") t = setTimeout(() => setSt(null), 4000);
    };
    window.addEventListener(EXPORT_EVENT, on);
    return () => { window.removeEventListener(EXPORT_EVENT, on); clearTimeout(t); };
  }, []);
  if (!st) return null;
  const pct = st.total ? Math.round((st.done / st.total) * 100) : (st.phase === "done" ? 100 : 15);
  const n = (x) => Number(x || 0).toLocaleString("en-GB");
  return (
    <div className="export-status" role="status" aria-live="polite">
      <div className="export-status-head">
        <b>{st.phase === "done"
          ? (st.fallback ? "Excel could not be built, so you have the plain CSV instead"
            : `✓ Downloaded ${n(st.rows)} row${st.rows === 1 ? "" : "s"}${st.partial ? " (some details could not be fetched)" : ""}`)
          : (st.kind === "xlsx" ? "Preparing your Excel file…" : "Preparing your CSV…")}</b>
        {st.phase !== "done" && st.total > 0 && <span className="muted small">{n(st.done)} of {n(st.total)} companies</span>}
      </div>
      <div className="export-status-bar"><div style={{ width: `${pct}%` }} /></div>
      {st.phase !== "done" && <div className="muted small">{st.kind === "xlsx"
        ? "Adding every signal, contract, contact and call for each company."
        : "Adding each company's calling details — the decision maker, phones and address."}</div>}
    </div>
  );
}
